module.exports = __webpack_public_path__ + "static/media/manage.ffb29144.svg";